import { Affix, Avatar, Badge, Card, Col, Divider, Modal, Row, Typography } from 'antd';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import PersonalAnalyst from '../../../components/widgets/Different-Widgets/personalAnalyst';
import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined, LockOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import AnalystInformation from '../MortagageAplication/DocumetationNew/Modals/AgentInformation';
import StagesMortgages from '../../../components/widgets/Different-Widgets/stagesMortgagesWidget';
import AutomaticDocumentationStartupModal from 'mortgage-documents/src/document-boxes/AutomaticDocumentation/Modal/AutomaticDocumentationStartupModal';
import DocumentationAccordions from './DocumentationAccordion/DocumentationAccordions';
import { Request } from './Utils/types';
import numeral from 'numeral';
import i18n from '../../../i18n';
import moment from 'moment';
import FooterComponent from '../../../components/footer/footerComponent';
import _ from 'lodash';
import ModalPayPending from './Components/ModalPayPending';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;
const logoBE = require('../../../assets/onboarding/logoBE.png');

export type ReduxStore = {
	auth: StoreAuth;
	data: StoreAuth;
};

export type StoreAuth = {
	token: string;
	roles: string;
	operations: any;
	dataProfile: any;
};

const DocumentatitonCore = ({ stages, userMortgageId, valuesDataAgent }) => {
	const userToken = useSelector<ReduxStore, string>((state) => state.auth.token);
	const [analystData, setAnalystData] = useState<any>(undefined);
	const { t } = useTranslation();
	const dataProfile = useSelector<ReduxStore, any>((state) => state.data.dataProfile);
	const [modalStage, setModalStage] = useState<any>(false);
	const [mortgage, setMortgage] = useState<any>(undefined);
	const [showAppraisal, setShowAppraisal] = useState<boolean>(false);
	const [allDenied, setAllDenied] = useState<boolean>(false);
	const [nameOperations, setNameOperations] = useState<any>(undefined);
	const [owners, setOwners] = useState<any>(undefined);
	const [dataResume, setDataResume] = useState<boolean>(false);
	const [nameBanks, setNameBanks] = useState<any[]>([]);
	const [modalPay, setModalPay] = useState<boolean>(false);
	const navigate = useNavigate();

	useEffect(() => {
		getOperationSummary();
		getPhoto();
		getDataOperation();
		getBanks();
		if (stages === 'banks') {
			getBankRequest();
		}
	}, []);

	useEffect(() => {
		renderTitleByStages();
		renderTextByStages();
	}, [showAppraisal, stages]);

	const getOperationSummary = () => {
		axios
			.get(`${env.api.url}/operations/operation/summary`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				const operation = response.data.data.find(
					(operation) => operation.operationId === userMortgageId
				);
				setNameOperations(operation);

				setOwners(operation.owners);
			});
	};

	const getBanks = () => {
		axios
			.get(`${env.api.url}/v1/banks/get-banks`, {
				headers: {
					Authorization: `Bearer ${userToken}`
				}
			})
			.then((response) => {
				setNameBanks(response.data.data);
			});
	};

	const getBankRequest = () => {
		axios
			.get(`${env.api.url}/v1/banks/get-operation-bank-requests/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				const denyBank = response.data.data.filter((request: Request) => {
					if (request.status === 'deny') {
						return request;
					}
				});
				if (denyBank.length === response.data.data.length) {
					setAllDenied(true);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getDataOperation = () => {
		axios
			.get(`${env.api.url}/v1/operations/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setMortgage(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const getPhoto = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/agents/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setAnalystData(response.data.data);
			});
	};

	const renderTitleByStages = () => {
		if (stages === 'documents') {
			return t('name.docsNew2', { name: dataProfile?.name });
		} else if (stages === 'analysis') {
			return dataProfile?.name + ', ' + t('name.analysisNew');
		} else if (stages === 'banks' && allDenied === false) {
			return dataProfile?.name + ', ' + t('name.banksNew');
		} else if (stages === 'banks' && allDenied) {
			return dataProfile?.name + ', ' + t('name.banksNewDenied');
		} else if (stages === 'oferts' && !showAppraisal) {
			return t('name.ofertsNew', { name: dataProfile?.name });
		} else if (stages === 'appraisal' || showAppraisal) {
			return t('name.appraisalNew', { name: dataProfile?.name });
		} else if (stages === 'formalization') {
			return t('name.formalizationNew');
		}
	};

	const renderTextByStages = () => {
		if (stages === 'documents') {
			return t('doc.requiredDocumentsMessage');
		} else if (stages === 'analysis') {
			return t('name.analysisNew2');
		} else if (stages === 'banks' && allDenied === false) {
			return t('name.banksNew2');
		} else if (stages === 'banks' && allDenied) {
			return t('name.banksNew3');
		} else if (stages === 'oferts' && !showAppraisal) {
			return t('name.ofertsNew2') + '. ' + t('name.ofertsNew3');
		} else if (stages === 'appraisal' || showAppraisal) {
			return t('name.appraisalNew2');
		} else if (stages === 'formalization') {
			return t('name.formalizationNew2');
		}
	};

	const renderJob = (value) => {
		const options = [
			{ label: 'viability.fixedearner', value: 'EMPLOYEE_FIXED' },
			{ label: 'viability.employeeFixedSeasonal', value: 'EMPLOYEE_FIXED_SEASONAL' },
			{ label: 'viability.employeeTemporary', value: 'EMPLOYEE_TEMPORAL' },
			{ label: 'form.autonomous', value: 'FREELANCER' },
			{ label: 'form.businessOwner', value: 'BUSINESS_OWNER' },
			{ label: 'form.official', value: 'FUNCTIONARY' },
			{ label: 'form.pensioner', value: 'PENSIONER' },
			{ label: 'form.rentier', value: 'RENTIER' },
			{ label: 'form.officialInterim', value: 'FUNCTIONARY_INTERIM' },
			{ label: 'form.unemployed', value: 'UNEMPLOYED' },
			{ label: 'form.unknow', value: 'UNKNOW' }
		];
		return t(options.find((item) => item.value === value).label);
	};

	let documentViability;
	if (mortgage) {
		if (mortgage.subtype === 'subrogation') {
			axios
				.get(`${env.api.url}/v1/mortgages/generate-pdf-viabilidad-subrogacion/${userMortgageId}`, {
					headers: {
						Authorization: `Bearer ${userToken}`
					}
				})
				.then((response) => {
					documentViability = response.data.url;
				});
		} else if (mortgage?.operationData.mortgage.houseState === 'have_decide') {
			documentViability = `${env.api.url}/v1/banks/generate-pdf-viabilidad-casaElegida/${userMortgageId}/${i18n.language}?token=${userToken}`;
		} else if (
			mortgage?.operationData.mortgage.houseState === 'searching' &&
			mortgage?.operationData?.mortgage?.viabilityData?.operation &&
			mortgage?.operationData.mortgage.viabilityData.operation.mortgageAmountLimit === 'savings'
		) {
			documentViability = `${env.api.url}/v1/banks/generate-pdf-viabilidad-limite-ahorro/${userMortgageId}/${i18n.language}?token=${userToken}`;
		} else if (
			mortgage?.operationData.mortgage.houseState === 'searching' &&
			mortgage?.operationData?.mortgage?.viabilityData?.operation &&
			mortgage?.operationData.mortgage.viabilityData.operation.mortgageAmountLimit === 'fixed'
		) {
			documentViability = `${env.api.url}/v1/banks/generate-pdf-viabilidad-limite-endeudamiento/${userMortgageId}/${i18n.language}?token=${userToken}`;
		}
	}

	const DocumentsResidentMortgageEs =
		'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/documents/docu_bienvenida_hipoteca_residentes_es.pdf';
	const DocumentsResidentMortgageEn =
		'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/documents/docu_bienvenida_hipoteca_residentes_en.pdf';
	const DocumentsResidentMortgageCat =
		'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/documents/docu_bienvenida_hipoteca_residentes_cat.pdf';

	let documentToDownload;

	if (i18n.language === 'es' || i18n.language === 'es-ES') {
		documentToDownload = DocumentsResidentMortgageEs;
	} else if (i18n.language === 'en') documentToDownload = DocumentsResidentMortgageEn;
	else {
		documentToDownload = DocumentsResidentMortgageCat;
	}
	const renderRow = ({ label, data }) => {
		return (
			<Row style={{ marginBottom: 4 }}>
				<Col span={isMobileOnly ? 12 : 7}>
					<Text style={{ color: '#666666', fontSize: 14, fontWeight: 400 }}>{label}</Text>
				</Col>
				<Col
					span={isMobileOnly ? 12 : 17}
					style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
					<Text style={{ color: '#262626', fontSize: 14, fontWeight: 600 }}>
						{data ? data : '-'}
					</Text>
				</Col>
			</Row>
		);
	};

	return (
		<div
			style={{
				paddingLeft: isMobileOnly ? 16 : 24,
				paddingRight: isMobileOnly ? 16 : 24,
				paddingTop: 16,
				paddingBottom: 150,
				width: '100%'
			}}>
			<Row
				gutter={24}
				style={{
					minHeight: 'calc(100vh - 200px)',
					boxSizing: 'border-box'
				}}>
				<Col lg={18} md={18} sm={18} xs={24} xl={18} xxl={18}>
					{isMobileOnly && <div style={{ marginTop: 50 }}></div>}
					{isMobileOnly &&
						!_.isNil(mortgage?.operationData?.mortgage?.appraisalAmount) &&
						mortgage?.operationData?.mortgage?.appraisalPaid !== true && (
							<div
								onClick={() => navigate(`/payments/operations/${userMortgageId}`)}
								style={{
									position: 'absolute',
									top: 18,
									right: 180,
									background: '#FEF0D3',
									borderBottomLeftRadius: '8px',
									borderTopRightRadius: '8px',
									height: 32,
									padding: '0px 16px',
									textAlign: 'center',
									display: 'flex'
								}}>
								<div style={{ marginLeft: -20, marginRight: 8, marginTop: -5 }}>
									<Badge count={1} size="small" className="gb-badget"></Badge>
								</div>
								<div style={{ marginTop: 4 }}>
									<Text style={{ fontSize: 14, fontWeight: 600, color: '#2F4858' }}>
										{t('pending.pay1')}
									</Text>

									<ShoppingCartOutlined
										style={{
											color: '#2F4858',
											fontSize: 20,
											marginLeft: 5
										}}></ShoppingCartOutlined>
								</div>
							</div>
						)}
					{isMobileOnly && (
						<div
							style={{
								position: 'absolute',
								top: 12,
								right: 15,
								background: '#E8ECF4',
								borderTopLeftRadius: 4,
								borderTopRightRadius: 4,
								padding: 8,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								gap: 4
							}}>
							<Text style={{ fontSize: 12, fontWeight: 400, color: '#262626' }}>
								{t('b2bOperationList.stage') + ': '}
							</Text>
							<Text style={{ fontSize: 14, fontWeight: 600, color: '#262626' }}>
								{showAppraisal
									? t(`stages.${'appraisal'}`)
									: stages === 'banks' || stages === 'oferts'
									? t('step.ofertsCustomer')
									: stages === 'analysis'
									? t('stages.documents')
									: t(`stages.${stages}`)}
							</Text>
							<InfoCircleOutlined
								style={{ color: '#0D0D0D', fontSize: 20, cursor: 'pointer' }}
								onClick={() => setModalStage(!modalStage)}></InfoCircleOutlined>
						</div>
					)}
					{!isMobileOnly &&
						!_.isNil(mortgage?.operationData?.mortgage?.appraisalAmount) &&
						mortgage?.operationData?.mortgage?.appraisalPaid !== true && (
							<div
								onClick={() => setModalPay(!modalPay)}
								style={{
									position: 'absolute',
									top: -10,
									right: 15,
									background: '#FEF0D3',
									borderTopLeftRadius: '8px',
									borderTopRightRadius: '8px',
									height: 32,
									padding: '0px 16px',
									textAlign: 'center',
									cursor: 'pointer',
									zIndex: 1000,
									display: 'flex'
								}}>
								<div style={{ marginLeft: -20, marginRight: 8, marginTop: -5 }}>
									<Badge count={1} size="small" className="gb-badget"></Badge>
								</div>
								<div style={{ marginTop: 4 }}>
									<Text style={{ fontSize: 12, fontWeight: 400, color: '#2F4858' }}>
										{t('pending.pay')}
									</Text>

									<ShoppingCartOutlined
										style={{
											color: '#2F4858',
											fontSize: 14,
											marginLeft: 5
										}}></ShoppingCartOutlined>
								</div>
							</div>
						)}

					<Card className="gb-card-0px" style={{ marginTop: isMobileOnly ? 0 : 20 }}>
						<Row
							style={{
								marginBottom: isMobileOnly ? undefined : -20,
								marginTop: isMobileOnly ? undefined : -20
							}}>
							{!isMobileOnly && analystData?.analyst && (
								<Col span={3} style={{ minWidth: 110 }}>
									{analystData?.analyst?.avatar ? (
										<div
											style={{
												position: 'absolute',
												bottom: 20,

												width: '100%',
												height: '100%',
												maxHeight: 96,
												backgroundImage: `url(${analystData?.analyst?.avatar?.link})`,
												backgroundRepeat: 'no-repeat',
												backgroundSize: 'contain',
												backgroundPosition: 'left bottom'
											}}></div>
									) : (
										<Avatar
											style={{
												position: 'absolute',
												top: '50%',
												left: '50%',
												transform: 'translate(-50%, -50%)',
												width: 80,
												height: 80,
												backgroundColor: '#ccc',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												fontSize: 30
											}}>
											{analystData?.analyst?.name
												? analystData?.analyst?.name[0].toUpperCase()
												: 'U'}
										</Avatar>
									)}
								</Col>
							)}

							<Col
								span={isMobileOnly ? 24 : 13}
								style={{
									padding: isMobileOnly ? 16 : 24,
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center'
								}}>
								<div style={{ marginBottom: isMobileOnly ? 5 : undefined }}>
									<Text
										className="title-head"
										style={{
											color: '#262626',
											fontSize: isMobileOnly ? 16 : 20,
											fontWeight: 600
										}}>
										{renderTitleByStages()}
									</Text>
								</div>
								<div style={{ lineHeight: 1.22 }}>
									<Text style={{ color: '#666', fontSize: 14, fontWeight: 400 }}>
										{renderTextByStages() + ' '}
									</Text>
								</div>
							</Col>
							{!isMobileOnly && (
								<div
									style={{
										background: 'var(--Neutral-L2, #E5E5E5)',
										width: 1,
										height: 60,
										marginTop: 45
									}}></div>
							)}
							{isMobileOnly && (
								<div
									style={{
										background: 'var(--Neutral-L2, #E5E5E5)',
										width: '90%',
										height: 1,
										marginLeft: 16,
										marginTop: -5
									}}></div>
							)}
							<Col
								span={isMobileOnly ? 24 : 7}
								style={{
									padding: isMobileOnly ? 16 : 24,
									marginTop: isMobileOnly ? -20 : 10
								}}>
								{!isMobileOnly && (
									<div style={{ marginTop: 8 }}>
										<Text
											style={{
												color: '#262626',
												fontSize: isMobileOnly ? 16 : 14,
												fontWeight: 600
											}}>
											{mortgage?.subtype === 'mortgage'
												? t('resume.docsTitle')
												: t('doc.summaryData')}
										</Text>
									</div>
								)}
								{!isMobileOnly && (
									<Row style={{ marginTop: 5, width: '100%' }}>
										<Col span={10} style={{ display: 'flex', flexDirection: 'column' }}>
											<Text style={{ color: '#666666', fontSize: 12, fontWeight: 400 }}>
												{mortgage?.subtype === 'mortgage'
													? t('yourHouse.doc')
													: t('form.pendingCapital')}
											</Text>
											<Text style={{ color: '#262626', fontSize: 12, fontWeight: 400 }}>
												{mortgage?.subtype === 'mortgage'
													? numeral(mortgage?.operationData?.mortgage?.maxBudget).format('0,0 $')
													: numeral(mortgage?.operationData?.subrogation?.maxBudget).format(
															'0,0 $'
													  )}
											</Text>
										</Col>
										<Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
											<Text style={{ color: '#666666', fontSize: 12, fontWeight: 400 }}>
												{mortgage?.subtype === 'mortgage'
													? t('amountHouse.doc')
													: t('form.currentInterest')}
											</Text>
											{mortgage?.subtype === 'mortgage' && (
												<Text style={{ color: '#262626', fontSize: 12, fontWeight: 400 }}>
													{numeral(
														mortgage?.operationData?.mortgage?.viabilityData?.operation
															?.mortgageAmount === 0
															? Number(
																	mortgage?.operationData?.mortgage?.viabilityData?.operation
																		?.taxes +
																		mortgage?.operationData?.mortgage?.maxBudget -
																		mortgage?.operationData?.mortgage?.viabilityData?.operation
																			?.savings
															  ) + 2000
															: mortgage?.operationData?.mortgage?.viabilityData?.operation
																	?.mortgageAmount
													).format('0,0.00 $')}
												</Text>
											)}
											{mortgage?.subtype === 'subrogation' &&
												mortgage?.operationData?.subrogation?.interest &&
												mortgage?.operationData?.subrogation?.haveATin && (
													<Text style={{ color: '#262626', fontSize: 12, fontWeight: 500 }}>
														{mortgage?.operationData?.subrogation?.interest === 'fixed'
															? t('form.fixed')
															: mortgage?.operationData?.subrogation?.interest === 'variable'
															? t('form.variable')
															: t('loan.mixedOnboarding')}
														{mortgage?.operationData?.subrogation?.interest === 'fixed'
															? ` (${mortgage?.operationData?.subrogation?.haveATin
																	.toString()
																	.replace('.', ',')}%)`
															: mortgage?.operationData?.subrogation?.interest === 'variable'
															? ` (Eur + ${mortgage?.operationData?.subrogation?.haveATin
																	.toString()
																	.replace('.', ',')}%)`
															: ` (${mortgage?.operationData?.subrogation?.initialInterestVariable
																	.toString()
																	.replace(
																		'.',
																		','
																	)}% / Eur + ${mortgage?.operationData?.subrogation?.finalInterestVariable
																	.toString()
																	.replace('.', ',')}%) `}
													</Text>
												)}
										</Col>
									</Row>
								)}
								{isMobileOnly && (
									<Col span={24} style={{ display: 'flex', flexDirection: 'column', marginTop: 5 }}>
										<div
											onClick={() => setDataResume(true)}
											style={{
												color: '#C80000',
												fontSize: 14,
												fontWeight: 500,
												textAlign: 'center',
												cursor: 'pointer'
											}}>
											{t('seeMore.resumeEV')}
										</div>
									</Col>
								)}
								{!isMobileOnly && (
									<div
										onClick={() => setDataResume(true)}
										style={{
											color: '#C80000',
											fontSize: 14,
											fontWeight: 500,
											position: 'relative',
											bottom: 20,
											left: 40,
											textAlign: 'right',
											cursor: 'pointer'
										}}>
										{t('promoterLoan.seeMore')}
									</div>
								)}
							</Col>
						</Row>
					</Card>
					<DocumentationAccordions
						userMortgageId={userMortgageId}
						stages={stages}
						showAppraisal={showAppraisal}
						setShowAppraisal={setShowAppraisal}
					/>
				</Col>

				<Col lg={6} md={6} sm={6} xs={24} xl={6} xxl={6} style={{ marginTop: -20 }}>
					{!isMobileOnly && (
						<>
							<Card className="gb-card-16px">
								<PersonalAnalyst
									analyst={
										nameOperations !== undefined ? nameOperations : valuesDataAgent
									}></PersonalAnalyst>
							</Card>

							<Card className="gb-card-16px" style={{ marginTop: 16, textAlign: 'initial' }}>
								<div style={{ marginBottom: -16 }}>
									<Text style={{ fontSize: 12, fontWeight: 400, color: '#666666' }}>
										{t('document.modatTitlteSteper').toUpperCase()}
									</Text>
								</div>
								<StagesMortgages data={{ data: { stage: stages } }} />
							</Card>
						</>
					)}
				</Col>
			</Row>
			<FooterComponent />

			{/* <Row style={{ display: 'flex', justifyContent: 'center' }}>
				{isMobileOnly ? (
					<>
						<div style={{ marginTop: 32, width: '100%' }}>
							<div
								style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
								<LockOutlined style={{ color: '#808080', fontSize: 14 }} />
								<Text style={{ fontSize: 10, fontWeight: 400, color: '#808080', marginLeft: 8 }}>
									{t('doc.ourSecureInformation').replace(/:$/, '.')}
								</Text>
							</div>
							<Divider style={{ margin: 8 }} />
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<img src={logoBE} alt="Logo Banco de Españana" />
								<Text style={{ fontSize: 8, fontWeight: 400, color: '#808080', marginLeft: 6 }}>
									Certificada como Intermediaria
									<br />
									de Crédito Inmobiliario nº: D842
								</Text>
							</div>
						</div>
					</>
				) : (
					<>
						<Divider style={{ marginBottom: 16 }} />
						<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
								<LockOutlined style={{ color: '#808080', fontSize: 20 }} />
								<Text style={{ fontSize: 12, fontWeight: 400, color: '#808080' }}>
									{t('doc.ourSecureInformation')}
								</Text>
							</div>
							<img src={logoBE} alt="Logo Banco de Españana" />
							<Text style={{ fontSize: 10, fontWeight: 400, color: '#808080' }}>
								Certificada como Intermediaria
								<br />
								de Crédito Inmobiliario nº: D842
							</Text>
						</div>
					</>
				)}
			</Row> */}

			{isMobileOnly && (
				<AnalystInformation
					name={undefined}
					phone={undefined}
					email={undefined}
					image={undefined}
					dataValues={analystData}
					valuesDataAgent={valuesDataAgent}
				/>
			)}

			<Modal
				title={t('document.modatTitlteSteper')}
				className="ModalCommon"
				width={480}
				cancelButtonProps={{
					style: { display: 'none' }
				}}
				okButtonProps={{
					style: { display: 'none' }
				}}
				open={modalStage}
				onCancel={() => setModalStage(!modalStage)}
				destroyOnClose={true}
				closable={true}>
				<div style={{ marginTop: -35, marginBottom: -30 }}>
					<StagesMortgages data={{ data: { stage: stages } }} />
				</div>
			</Modal>

			<Modal
				title={t('title.resumeDoc')}
				className={'ModalResume'}
				width={isMobileOnly ? 378 : 581}
				footer={null}
				open={dataResume}
				onCancel={() => setDataResume(false)}
				destroyOnClose={true}
				closable={true}>
				<div style={{ marginTop: 12 }}>
					<Text style={{ color: '#666666', fontSize: 14, fontWeight: 400 }}>
						{t('title.resumeDoc1')}
					</Text>
				</div>
				{mortgage?.subtype === 'subrogation' ? (
					<div style={{ marginTop: isMobileOnly ? 16 : 20 }}>
						{renderRow({
							label: t('form.locationHouse') + ':', //Ubicación de la casa
							data: mortgage?.operationData?.subrogation?.province
						})}
						{renderRow({
							label: t('form.houseCost') + ':', //Coste de la casa
							data: numeral(mortgage?.operationData?.subrogation?.maxBudget).format('0,0 $')
						})}
						{renderRow({
							label: t('form.pendingCapital') + ':', //Capital pendiente
							data: numeral(mortgage?.operationData?.subrogation?.amount).format('0,0 $')
						})}
						{renderRow({
							label: t('form.dateInitial') + ':', //Fecha de firma
							data: moment(mortgage?.operationData?.subrogation?.dateSign).format('MM-YYYY')
						})}
						{renderRow({
							label: t('form.endDate') + ':', //Fecha finalización
							data: moment(mortgage?.operationData?.subrogation?.dateEndMortgage).format('MM-YYYY')
						})}
						{renderRow({
							label: t('loan.entityBank') + ':', //Entidad bancaria
							data: nameBanks.find(
								(bank) => bank.id === mortgage?.operationData?.subrogation?.mortgageCurrentBank
							)?.name
						})}
						{mortgage?.operationData?.subrogation?.initialInterestVariable &&
							mortgage?.operationData?.subrogation?.interest &&
							mortgage?.operationData?.subrogation?.haveATin &&
							mortgage?.operationData?.subrogation?.finalInterestVariable && (
								<>
									{renderRow({
										label: t('form.currentInterest') + ':', //Tipo interés actual
										data: (
											<>
												{mortgage?.operationData?.subrogation?.interest === 'fixed'
													? t('form.fixed')
													: mortgage?.operationData?.subrogation?.interest === 'variable'
													? t('form.variable')
													: t('loan.mixedOnboarding')}
												{isMobileOnly ? <br /> : '\u00A0'}
												<Text style={{ fontSize: 12 }}>
													{mortgage?.operationData?.subrogation?.interest === 'fixed'
														? ` (${mortgage?.operationData?.subrogation?.haveATin
																.toString()
																.replace('.', ',')}%)`
														: mortgage?.operationData?.subrogation?.interest === 'variable'
														? ` (Eur + ${mortgage?.operationData?.subrogation?.haveATin
																.toString()
																.replace('.', ',')}%)`
														: ` (${mortgage?.operationData?.subrogation?.initialInterestVariable
																.toString()
																.replace('.', ',')}%
									/ Eur + ${mortgage?.operationData?.subrogation?.finalInterestVariable
										.toString()
										.replace('.', ',')}%) `}
												</Text>
											</>
										)
									})}
								</>
							)}
					</div>
				) : (
					<div style={{ marginTop: isMobileOnly ? 16 : 20 }}>
						{renderRow({
							label: t('viability.provinceViability') + ':', //Provincia de compra
							data: mortgage?.operationData?.mortgage?.province
						})}
						{isMobileOnly ? (
							<>
								{renderRow({
									label: t('form.propertyType') + ':', //Propiedad
									data:
										mortgage?.operationData?.mortgage?.propertyType === 'newConstruction'
											? t('form.newBuild')
											: t('form.secondHand')
								})}
								{renderRow({
									label: t('viability.expectedUse') + ':', //Uso previsto
									data:
										mortgage?.operationData?.mortgage?.houseType === 'main'
											? t('form.main')
											: t('form.second')
								})}
							</>
						) : (
							<>
								{renderRow({
									label: t('property.used'), //Propiedad y uso
									data: `${
										mortgage?.operationData?.mortgage?.propertyType === 'newConstruction'
											? t('form.newBuild')
											: t('form.secondHand')
									}, ${
										mortgage?.operationData?.mortgage?.houseType === 'main'
											? t('form.main')
											: t('form.second')
									}`
								})}
							</>
						)}
						{renderRow({
							label: t('budget.price') + ':', //Precio de la vivienda
							data: numeral(mortgage?.operationData?.mortgage?.maxBudget).format('0,0 $')
						})}
						{renderRow({
							label: t('form.Savings') + ':', //Ahorros disponibles
							data: numeral(mortgage?.operationData?.mortgage?.savings).format('0,0 $')
						})}
						{renderRow({
							label: t('amount.need'), //Hipoteca necesaria
							data: numeral(
								mortgage?.operationData?.mortgage?.viabilityData?.operation?.mortgageAmount === 0
									? Number(
											mortgage?.operationData?.mortgage?.viabilityData?.operation?.taxes +
												mortgage?.operationData?.mortgage?.maxBudget -
												mortgage?.operationData?.mortgage?.viabilityData?.operation?.savings
									  ) + 2000
									: mortgage?.operationData?.mortgage?.viabilityData?.operation?.mortgageAmount
							).format('0,0 $')
						})}
					</div>
				)}
				<div>
					{owners &&
						owners.map((owner, index) => {
							return (
								<>
									<Row style={{ marginTop: isMobileOnly ? 16 : 24 }}>
										<Text style={{ color: '#666666', fontSize: 14, fontWeight: 600 }}>
											{t(`form.owner${index + 1}`) + ':'}
										</Text>
										<Text
											style={{ color: '#666666', fontSize: 14, fontWeight: 600, marginLeft: 6 }}>
											{owner.name}
											{owner.age ? ', ' : ''}
										</Text>{' '}
										&nbsp;
										{owner.age && (
											<Text style={{ color: '#666666', fontSize: 14, fontWeight: 600 }}>
												{owner.age} {t('viability.years')}
											</Text>
										)}
									</Row>
									<Divider
										style={{ margin: 0, marginBottom: 4, color: '#C0DAEE', background: '#C0DAEE' }}
									/>
									<Row style={{ marginBottom: 4 }}>
										{owner.activity && (
											<Text style={{ color: '#262626', fontSize: 14, fontWeight: 600 }}>
												{renderJob(owner.activity)}
											</Text>
										)}
										{mortgage?.subtype !== 'subrogation' && (
											<>
												{owner.seniority !== undefined && owner.seniority > 0 && (
													<Text
														style={{
															color: '#262626',
															fontSize: 14,
															fontWeight: 600,
															marginLeft: 6
														}}>
														{' / ' + owner.seniority + ' ' + t('viability.years') + ' / '}&nbsp;
													</Text>
												)}
												{owner.netIncomes !== undefined && owner.netIncomes > 0 && (
													<Text style={{ color: '#262626', fontSize: 14, fontWeight: 600 }}>
														{numeral(owner.netIncomes).format('0,0 $') +
															' ' +
															t('viability.monthsEstimated')}
													</Text>
												)}
											</>
										)}
									</Row>
									{mortgage?.subtype !== 'subrogation' && (
										<Row>
											<Text style={{ color: '#262626', fontSize: 14, fontWeight: 600 }}>
												{t('others.loansDocs')}
											</Text>
											<Text style={{ color: '#262626', fontSize: 14, fontWeight: 600 }}>
												{': ' + numeral(owner.loanPayment).format('0,0 $')}
											</Text>
										</Row>
									)}
								</>
							);
						})}
				</div>
			</Modal>

			{stages === 'documents' && mortgage && (
				<AutomaticDocumentationStartupModal
					userMortgageId={userMortgageId}
					clickTab={'owner1'}
					mortgage={mortgage}
					env={env}
					platform="engel"
					traceSadabdell={undefined}
				/>
			)}
			<ModalPayPending
				getDataOperation={getDataOperation}
				setModalPay={setModalPay}
				modalPay={modalPay}
				mortgage={mortgage}
				operationId={userMortgageId}></ModalPayPending>
		</div>
	);
};
export default DocumentatitonCore;
